import type { Typography } from '../../style/color';

const DefaultTypography: Typography = {
  fontFamily: ['Roboto', 'sans-serif'].join(','),
};

export default DefaultTypography;
